export default __webpack_public_path__ + "static/media/downArrowWhite.8db21c43.svg";